import Head from 'next/head';
import Link from 'next/link';

import { NCDGeneralHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{NCDGeneralHelpSEO.metaTitle}</title>
        <meta name="description" content={NCDGeneralHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={NCDGeneralHelpSEO.metaOGDescription}
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">NCD Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                General
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">General</h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  What is NCD (Non-Convertible Debenture)?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    NCD is the abbriviation for Non-Convertible Debenture. It is
                    a type of debt instrument issued by a company to raise
                    capital from its investors. NCDs offer fixed interest rates
                    and a specific maturity period, during which the issuing
                    company pays regular and fixed interest payments to its
                    debenture holders. Unlike the regular convertible
                    debentures, you cannot convert NCDs into equity
                    shares.Investors in NCDs receive their interest income
                    periodically. These are monthly, quarterly, or annually,
                    depending on the terms of the debenture. At the end of the
                    NCD maturity period, the issuing company then returns the
                    principal amount to its debenture holders.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  Benefits of investing in Muthoot FinCorp Ltd’s NCD?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    <span className="text--bold">Higher interest rates:</span>
                    Muthoot FinCorp Ltd.&apos;s NCDs generally offer higher
                    interest rates compared to traditional fixed deposit schemes
                    or savings accounts available in the market. With an
                    investment in NCD, you can potentially get higher returns on
                    your investment.
                  </p>

                  <p className="text--semi text--gray answer">
                    <span className="text--bold">Regular income:</span>
                    NCDs have periodic interest payouts, which can be monthly,
                    quarterly, or annually. This can be beneficial if you are
                    seeking a regular income stream from your investments.
                  </p>

                  <p className="text--semi text--gray answer">
                    <span className="text--bold">Diversification:</span>
                    Investing in Muthoot FinCorp Ltd.&apos;s NCDs can diversify
                    your investment portfolio as they provide an alternative
                    investment avenue to stocks, mutual funds, and other
                    traditional investment options.
                  </p>

                  <p className="text--semi text--gray answer">
                    <span className="text--bold">Fixed tenure: </span>NCDs have
                    fixed tenure, ranging from a few months to several years.
                    This allows you to align your investments with your
                    financial goals and choose the tenure that suits your
                    requirement.
                  </p>

                  <p className="text--semi text--gray answer">
                    <span className="text--bold">High credit rating:</span>
                    Muthoot FinCorp Ltd. NCDs are assigned credit ratings by
                    established credit rating agencies. A higher credit rating
                    indicates the issuer&apos;s ability to meet its financial
                    obligations.
                  </p>

                  <p className="text--semi text--gray answer">
                    <span className="text--bold">Liquidity:</span>
                    Muthoot FinCorp Ltd. NCDs are listed on stock exchanges,
                    which provides liquidity to investors. If you need funds
                    before the maturity of NCD, you have the option to sell them
                    on the stock exchange. Please note that this is, subject to
                    market conditions and demand.
                  </p>

                  <p className="text--semi text--gray answer">
                    <span className="text--bold">Tax efficiency:</span>
                    NCDs may offer tax advantages depending on the prevailing
                    tax regulations the country. Interest income from NCDs is
                    generally taxable, but you may benefit from certain
                    deductions or exemptions.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  How to invest in NCDs?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    <p className="text--semi text--gray answer">
                      You can invest in NCDs either through the Muthoot FinCorp
                      ONE app or website. all you have to do is:
                    </p>
                    <ul>
                      <li className="text--semi text--gray answer">
                        &emsp;1.Log in to the Muthoot FinCorp ONE app or website
                      </li>
                      <li className="text--semi text--gray answer">
                        &emsp;2.Select NCD Investments
                      </li>
                      <li className="text--semi text--gray answer">
                        &emsp;3.Provide your email address and PAN.
                      </li>
                      <li className="text--semi text--gray answer">
                        &emsp;4.Select from the available NCD series
                      </li>
                      <li className="text--semi text--gray answer">
                        &emsp;5.Provide your DEMAT account details (please
                        ensure it is linked to your PAN)
                      </li>
                      <li className="text--semi text--gray answer">
                        &emsp;6.Provide the UPI address (VPA)
                      </li>
                      <li className="text--semi text--gray answer">
                        &emsp;7.Click to submit your application
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  What is the face value of NCD?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The face Value of an NCD refers to the nominal or par value
                    of the debenture. It is the initial value at which the
                    debenture is issued and represents the principal amount that
                    will be repaid to the debenture holder at the time of its
                    maturity.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  Do I need to complete my KYC to invest in NCD?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    No, KYC is not required to invest in NCD.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  What is the minimum and maximum amount that I can invest?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can invest in NCD with as little as Rs. 10,000 and a
                    maximum value of upto Rs. 5,00,000 through UPI. To make an
                    investment higher than Rs. 5,00,000 please visit the nearest
                    Muthoot FinCorp branch. Please note that it is mandatory to
                    have a DEMAT account to invest in NCD.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  How to invest in NCD through Muthoot FinCorp Ltd. branch?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can also visit your nearest Muthoot FinCorp Ltd. branch
                    to make an NCD investment. Here a branch associate will help
                    you in filling out the application form and complete the
                    necessary steps. Please ensure that you carry your PAN and
                    DEMAT account number and bank account details (Please note
                    that it is mandatory to have a DEMAT account to invest in
                    NCD).
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  Can I apply multiple times for NCD ?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you can apply multiple times through the app and
                    website, however, you can only apply for one option once.
                    Also, there is a cumulative maximum investment limit of Rs.
                    5,00,000. For example, if you apply first for Option 1 with
                    Rs. 2,00,000 as investment, in the second application you
                    can choose all the available Options apart from Option 1 and
                    invest up to Rs. 3,00,00 while doing so.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                <p className="text--black text--semi title">
                  Can I cancel my application?
                </p>
              </div>
              <div
                id="collapseNine"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you can cancel your application anytime when the
                    bidding window is open. It might usually take upto 24
                    working hours to receive confirmation post submitting
                    cancellation request.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
